import React, { useState } from "react";
import FetchOptionsSelect from "./FetshOptionsSelect";
import { useTranslation } from "react-i18next";
import { GetCorporateCustomers } from "../../api/corporate-customers/getCorporateCustomers";

const CorporateCustomersSelect = ({
  onChange,
  defaultCustomerIds = [],
  ...props
}) => {
  const { t } = useTranslation();
  const [options, setoptions] = useState([]);

  const formatCustomerOptions = (response) => {
    const formattedFetchOptions = response.data.map(fetchOption => ({
      value: fetchOption.id,
      label: fetchOption.corporate_name
    }))
    setoptions(formattedFetchOptions);
    return formattedFetchOptions
  };
  return (
    <FetchOptionsSelect
      onChange={(value) => {
        const option = options.find(option => option.value === value) || {};
        onChange(option);
      }}
      fetchOptionsFunction={GetCorporateCustomers}
      fetchOptionsFilterParams={{ limit: -1, offset: 0, status: 1 }}
      loadingPlaceholder={t("Loading client companies...")}
      placeholderText={t("Client Company Name")}
      defaultFetchOptionIds={defaultCustomerIds}
      formatFetchOptionsFunction={formatCustomerOptions}
      {...props}
    />
  );
};

export default CorporateCustomersSelect;
